import React, { useState, useRef } from "react";
import usePDA1071_R01Store from "./usePDA1071_R01Store";
import DateRangeInput from "src/components/common/DateRangeInput";

interface Props {
  onSearch: () => void;
  onRefetch: () => void;
}

const PDA1071_R01Search: React.FC<Props> = ({ onSearch }) => {
  const { searchParams, updateSearchParam } = usePDA1071_R01Store();
  const [keyboardEnabled, setKeyboardEnabled] = useState(false);
  const [lastTapTime, setLastTapTime] = useState(0);
  const searchInputRef = useRef<HTMLInputElement>(null);

  const handleDoubleTap = () => {
    const now = Date.now();
    if (now - lastTapTime < 300) {
      setKeyboardEnabled(true);
      searchInputRef.current?.focus();
    }
    setLastTapTime(now);
  };

  const toggleKeyboard = () => {
    setKeyboardEnabled(!keyboardEnabled);
    if (!keyboardEnabled) setTimeout(() => searchInputRef.current?.focus(), 100);
  };

  return (
    <div className="w-full bg-white p-4 pb-1 border-b border-gray-200">
      <div className="space-y-3">
        <div className="flex items-center gap-1">
          <label className="text-lg font-medium text-black w-20 flex-shrink-0">
            공정지시
          </label>
          <div className="flex-1 flex gap-1">
            <input
              ref={searchInputRef}
              type="text"
              value={searchParams.productWorkNo ?? ""}
              onChange={(e) => updateSearchParam("productWorkNo", e.target.value)}
              onClick={handleDoubleTap}
              inputMode={keyboardEnabled ? "text" : "none"}
              autoComplete="off"
              className="flex-1 max-w-[215px] px-2 py-0.5 text-lg border border-gray-300 rounded bg-white text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="공정지시번호"
            />
            <button
              type="button"
              onClick={toggleKeyboard}
              className={`w-10 flex-shrink-0 px-2 py-0.5 border border-gray-300 rounded transition-colors ${
                keyboardEnabled
                  ? "bg-blue-500 text-white"
                  : "bg-white text-gray-600 hover:bg-gray-50"
              }`}
              title={keyboardEnabled ? "키보드 숨기기" : "키보드 표시"}
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                />
              </svg>
            </button>
          </div>
        </div>

        <DateRangeInput
          startDate={searchParams.startDate ?? ""}
          endDate={searchParams.endDate ?? ""}
          onStartDateChange={(date) => updateSearchParam("startDate", date)}
          onEndDateChange={(date) => updateSearchParam("endDate", date)}
          label="공정기간"
          labelWidth="w-20"
        />

        <button
          onClick={onSearch}
          className="w-full bg-blue-500 text-white px-4 py-2 rounded text-lg font-medium hover:bg-blue-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          조회
        </button>
      </div>
    </div>
  );
};

export default PDA1071_R01Search;
